import {Component, Input, OnInit} from '@angular/core';

interface PostViewPrivacyE {
  ALL_FRIENDS: 'ALL_FRIENDS',
  CUSTOM: 'CUSTOM',
  EVERYONE: 'EVERYONE',
  FRIENDS_OF_FRIENDS: 'FRIENDS_OF_FRIENDS',
  SELF: 'SELF',
}

const privacyIconMap =  {
  ALL_FRIENDS: 'far fa-uses',
  CUSTOM: 'far  fa-cog',
  EVERYONE: 'far  fa-globe-americas',
  FRIENDS_OF_FRIENDS: 'far  fa-user-friends',
  SELF: 'far  fa-lock',
};


interface PostViewI {
  profile: {
    id: string;
    name: string;
    image: string;
  },
  dateTime: string;
  since: string;
  body: {
    preview?: string;
    media?: any[];
    content?: {
      title: string;
      description: string;
      image: string;
      link: string;
    }
  },
  permalink?: string;
  privacy?: PostViewPrivacyE;
  statistics : any[],
  reactions?: any,
  reactionStats?: any[],
}

@Component({
  selector: 'nw-post-card',
  templateUrl: './post-card.component.html',
  styleUrls: ['./post-card.component.scss']
})
export class NewellPostCardComponent implements OnInit {
  @Input() post: PostViewI;
  public reactions: any;
  public reactionsA: any;
  public privacyIcon: string;

  constructor() {}

  onImageLoad($event, index){
    const { naturalHeight, naturalWidth } = $event.target;
    if (naturalHeight === 1 || naturalWidth === 1) {
      this.post.body.media[index].link = 'assets/images/broken-image-link.jpg';
    }
  }

  ngOnInit() {
    const privacy: any = this.post.privacy;
    const reactions = this.post.reactions;
    const reactionStats = this.post.reactionStats;

    if (privacy) {
      this.privacyIcon = privacyIconMap[privacy];
    }

    if (reactions && reactions.length) {
      this.reactions = {
        icons: [],
        reactors: ''
      };

      const icons = new Set();
      let reactors = '';
      const ICONS = {
        LOVE: {
          type: 'love',
          icon: 'fas fa-heart'
        },
        LIKE: {
          type: 'like',
          icon: 'fas fa-thumbs-up'
        },
        WOW: {
          type: 'wow',
          icon: 'fas fa-heart'
        },
        HAHA: {
          type: 'wow',
          icon: 'fas fa-heart'
        },
        SAD: {
          type: 'wow',
          icon: 'fas fa-heart'
        },
        ANGRY: {
          type: 'wow',
          icon: 'fas fa-heart'
        },
        CARE: {
          type: 'care',
          icon: 'fas fa-hands-heart'
        },
      };
      reactions.forEach((react, index, { length }) => {
        if (ICONS[react.type]) {
          icons.add(ICONS[react.type]);
          reactors += `${react.value}${index === length - 1 ? '' : ','} `;
        }

      });

      this.reactions.icons = Array.from(icons);
      this.reactions.reactors = reactors;
    }

    if (reactionStats) {
      const stats = [];

      const ICONS = {
        LOVE: {
          type: 'love',
          icon: 'fas fa-heart',
          count: 0,
        },
        LIKE: {
          type: 'like',
          icon: 'fas fa-thumbs-up',
          count: 0,
        },
        WOW: {
          type: 'wow',
          icon: 'fas fa-surprise',
          count: 0,
        },
        HAHA: {
          type: 'wow',
          icon: 'fas fa-laugh-squint',
          count: 0,
        },
        SAD: {
          type: 'wow',
          icon: 'fas fa-frown',
          count: 0,
        },
        ANGRY: {
          type: 'wow',
          icon: 'fas fa-angry',
          count: 0,
        },
      };

      reactionStats.forEach(reaction => {
        if( ICONS[reaction.type]){
          stats.push({
            ...ICONS[reaction.type],
            count: reaction.count
          })
        }
      })

      this.reactionsA = stats;
    }

  }

}
